export default {
  Name: 'Назва',
};
